var x;!function(x){x.Xxs="xxs",x.Xsm="xs",x.Sml="s",x.Med="m",x.Lrg="l",x.Xlg="xl",x.Xxl="xxl"}(x||(x={}));export{x as IconsSize};
//# sourceMappingURL=icons.types.js.map
